// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".assignment-actions{position:relative}.assignment-actions i{margin-left:4px}.assignment-actions .spacer{height:1px;width:100%;border-bottom:1px solid rgba(0,0,0,.12549019607843137);margin:16px 0}.assignment-actions .title{width:100%;height:100%;text-align:center}.assignment-actions .action-card .apply-row{display:flex;width:100%;padding-top:16px}.assignment-actions .action-card .top-margin{margin-top:16px}", ""]);
// Exports
module.exports = exports;
